import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'

interface SkelDimProps {
  w?: CSSProperties['width']
  h?: CSSProperties['height']
  className?: string
  style?: CSSProperties
}

function Bar({ w, h, className, style }: SkelDimProps) {
  return <div className={cx('st-skel-bar', className)} style={{ width: w, height: h, ...style }} />
}

interface SkelBoxProps extends SkelDimProps {
  radius?: CSSProperties['borderRadius']
}

function Box({ w, h, radius, className, style }: SkelBoxProps) {
  return (
    <div className={cx('st-skel-box', className)} style={{ width: w, height: h, borderRadius: radius, ...style }} />
  )
}

interface SkelThumbProps {
  size?: CSSProperties['width']
  className?: string
  style?: CSSProperties
}

function Thumb({ size, className, style }: SkelThumbProps) {
  const sz = size ?? 36
  return <div className={cx('st-skel-thumb', className)} style={{ width: sz, height: sz, ...style }} />
}

interface SkelRowProps {
  children: ReactNode
  className?: string
  style?: CSSProperties
}

function Row({ children, className, style }: SkelRowProps) {
  return (
    <div className={cx('st-skel-row', className)} style={style}>
      {children}
    </div>
  )
}

export const Skeleton = { Bar, Box, Thumb, Row }
